import React from 'react'

function Footer() {

  return (
    <div className='w-full h-[2rem] hidden bg-secondery flex p-3 items-center text-light gap-3 justify-between'>
      <h1> (C) 2025  VClass - Virtual Classroom </h1>
      <a className='underline ' href='https://github.com/abancp/VClass' target="_blank" rel='noreferrer'>github</a>
    </div>
  )
}

export default Footer
